import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { fmtPHP, recordMeta } from "../../lib/finance";
import { KpiTile } from "./vehicleUtils";

export function VehicleFinanceTab({ records, locked }) {
  if (locked) {
    return (
      <div className="rounded-xl border border-slate-200 bg-slate-50 p-6 text-center" data-testid="vd-finance-locked">
        <Lock className="w-5 h-5 mx-auto text-slate-400" />
        <p className="mt-2 text-sm text-slate-600">Finance details are available on Pro/Enterprise plans for users with the <b>Finance</b> permission.</p>
        <Link to="/app/billing" className="mt-3 inline-flex items-center gap-1 text-sm text-[#1B4332] underline">Upgrade plan →</Link>
      </div>
    );
  }
  const totals = records.reduce((acc, r) => {
    const meta = recordMeta(r.record_type) || {};
    const sign = meta.sign || (["expense", "vehicle_cost", "maintenance_cost", "repair_cost", "fuel_cost", "insurance_cost", "registration_cost", "cleaning_cost", "staff_cost", "refund", "deposit_returned"].includes(r.record_type) ? -1 : 1);
    if (r.status === "paid") acc.net += sign * (r.amount || 0);
    if (sign > 0 && r.status === "paid") acc.income += r.amount || 0;
    if (sign < 0 && r.status === "paid") acc.expense += r.amount || 0;
    return acc;
  }, { income: 0, expense: 0, net: 0 });
  return (
    <div className="space-y-4" data-testid="vd-finance">
      <div className="grid sm:grid-cols-3 gap-3">
        <KpiTile label="Income (paid)" value={fmtPHP(totals.income)} tone="emerald" />
        <KpiTile label="Expenses (paid)" value={fmtPHP(totals.expense)} tone="rose" />
        <KpiTile label="Net" value={fmtPHP(totals.net)} tone={totals.net >= 0 ? "emerald" : "rose"} />
      </div>
      <div className="rounded-xl border border-slate-200 bg-white p-6">
        <h2 className="font-display text-lg font-semibold">Records</h2>
        {records.length === 0 ? (
          <div className="text-sm text-slate-500 py-3">No finance records linked to this vehicle yet.</div>
        ) : (
          <ul className="divide-y divide-slate-100 mt-3">
            {records.map((r) => {
              const meta = recordMeta(r.record_type) || { label: r.record_type, sign: 1 };
              return (
                <li key={r.id} className="py-3 flex items-start justify-between gap-3 text-sm" data-testid={`vd-fin-${r.id}`}>
                  <div className="min-w-0">
                    <div className="font-medium truncate">{r.title}</div>
                    <div className="text-xs text-slate-500">
                      {meta.label} · {(r.payment_method || "-").replace(/_/g, " ")} · {r.status}
                    </div>
                  </div>
                  <div className={`font-mono whitespace-nowrap ${meta.sign === -1 ? "text-rose-700" : "text-emerald-700"}`}>
                    {meta.sign === -1 ? "−" : "+"}{fmtPHP(r.amount)}
                  </div>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </div>
  );
}
